module.exports = __webpack_public_path__ + "assets/PurpleNoTx.2193a4d8cf152f80929a6e23ad057a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/PurpleNoTx.png
// module id = 1094
// module chunks = 0